// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes ColorChange {
  from {
    background-color: #fff;
    color: #000;
  }

  to {
    background-color: #56acb7;
    color: #fff;
  }
}

@media screen and (max-width: 991px) {
  .servicesContainer h1 {
    font-size: 2rem;
  }
}

@media screen and (min-width: 992px) {
  .servicesContainer h1 {
    font-size: 3rem;
  }
}

.servicesContainer {
  width: 100%;
  background-color: #f3f3f3;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.servicesContainer h1 {
  letter-spacing: 1px;
  font-weight: 500;
  /* display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; */
  padding: 24px;
  margin-top: 5%;
}

.bottomLine {
  width: 92px;
  height: 4px;
  margin-top: 12px;
  align-self: center;
  background-color: #56acb7;
}

.cardBottomLine {
  width: 15%;
  height: 2px;
  margin-top: 12px;
  align-self: center;
  background-color: #56acb7;
}

.serviceList {
  width: 100%;
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
}

.serviceList article {
  background-color: white;
  padding: 24px;
  margin: 24px;
  min-width: 320px;
  max-width: 350px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 10px 10px 10px #ddd;
  border-radius: 16px;
}

.serviceList article:hover {
  background-color: #56acb7;
  color: white;
  cursor: text;
  transition: background-color 0.3s ease-in, color 0.2s ease-in;
  box-shadow: none;
}

.serviceList h3 {
  font-size: 1.2rem;
  margin-top: 24px;
  letter-spacing: 1px;
}

.serviceList p {
  font-size: 0.9rem;
  margin-top: 32px;
  font-weight: 400;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/services/Services.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB;;;wBAGsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["@keyframes ColorChange {\n  from {\n    background-color: #fff;\n    color: #000;\n  }\n\n  to {\n    background-color: #56acb7;\n    color: #fff;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .servicesContainer h1 {\n    font-size: 2rem;\n  }\n}\n\n@media screen and (min-width: 992px) {\n  .servicesContainer h1 {\n    font-size: 3rem;\n  }\n}\n\n.servicesContainer {\n  width: 100%;\n  background-color: #f3f3f3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.servicesContainer h1 {\n  letter-spacing: 1px;\n  font-weight: 500;\n  /* display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; */\n  padding: 24px;\n  margin-top: 5%;\n}\n\n.bottomLine {\n  width: 92px;\n  height: 4px;\n  margin-top: 12px;\n  align-self: center;\n  background-color: #56acb7;\n}\n\n.cardBottomLine {\n  width: 15%;\n  height: 2px;\n  margin-top: 12px;\n  align-self: center;\n  background-color: #56acb7;\n}\n\n.serviceList {\n  width: 100%;\n  margin-top: 24px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.serviceList article {\n  background-color: white;\n  padding: 24px;\n  margin: 24px;\n  min-width: 320px;\n  max-width: 350px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 10px 10px 10px #ddd;\n  border-radius: 16px;\n}\n\n.serviceList article:hover {\n  background-color: #56acb7;\n  color: white;\n  cursor: text;\n  transition: background-color 0.3s ease-in, color 0.2s ease-in;\n  box-shadow: none;\n}\n\n.serviceList h3 {\n  font-size: 1.2rem;\n  margin-top: 24px;\n  letter-spacing: 1px;\n}\n\n.serviceList p {\n  font-size: 0.9rem;\n  margin-top: 32px;\n  font-weight: 400;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
